import React from 'react';
import { Empty } from 'antd';
import Chart from 'react-apexcharts';
import { useSelector } from 'react-redux';

import { formatters } from 'services';
import { selectors } from 'state';

const IndustryBarChart: React.FC = () => {
  const industryData = useSelector(selectors.equityPnlByIndustry);

  if (!industryData.length) {
    return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />;
  }

  const series = [
    {
      name: 'Short',
      data: industryData.map(i => ({
        x: i.industry,
        y: i.short,
      })),
    },
    {
      name: 'Long',
      data: industryData.map(i => ({
        x: i.industry,
        y: i.long,
      })),
    },
  ];

  return (
    <div style={{ marginTop: '-30px' }}>
      <Chart
        series={series}
        type="bar"
        options={{
          chart: {
            width: '100%',
            type: 'bar',
            toolbar: {
              show: false,
            },
            animations: {
              enabled: false,
            },
          },
          plotOptions: {
            bar: {
              horizontal: true,
              dataLabels: {
                position: 'top',
              },
            },
          },
          tooltip: {
            y: {
              formatter: formatters.million,
            },
          },
          dataLabels: {
            enabled: false,
          },
          xaxis: {
            labels: {
              formatter: formatters.million,
            },
          },
        }}
      />
    </div>
  );
};

export default IndustryBarChart;
